import { useMemo } from 'react'
import SvgColor from '../../../components/svg-color'
import { PATH_DASHBOARD } from '../../../routes/paths'

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
)

const ICONS = {
  eventz: icon('ic_ticket'),
}

export function useNavData() {
  const navRoutes = useMemo(
    () => [
      {
        subheader: 'Controle da Pista',
        items: [
          {
            title: 'Eventos',
            path: PATH_DASHBOARD.track.events,
            icon: ICONS.eventz,
          },
        ],
      },
    ],
    []
  )

  return navRoutes
}
